module.exports = __webpack_public_path__ + "3-54.jpg?4301788b1ddff31a34ec640bf3be2dee";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3-54.jpg
// module id = 136
// module chunks = 0